import { bookingStore } from 'entities/booking';
import { ITimeslot } from 'entities/timeslots/store/types';
import { FC, Fragment, useMemo } from 'react';
import { formatWithLocale } from 'shared/lib/date';
import { ButtonContained } from 'shared/ui/buttons/buttonContained';
import styles from './styles.module.scss';
import { useNavigate, useParams } from 'react-router-dom';
import { clinicsStore } from 'entities/clinics';
import { observer } from 'mobx-react-lite';
import { Doctor } from 'features/doctors/store/types';

interface AppointmentDoctorButtonProps {
	doctor: Doctor;
	selectedSlot: ITimeslot | null;
}

export const AppointmentDoctorButton: FC<AppointmentDoctorButtonProps> =
	observer(({ doctor, selectedSlot }) => {
		const navigate = useNavigate();
    const { id, view } = useParams();

    const clinic = useMemo(() => {
      if (selectedSlot?.branch) {
        const clinic = clinicsStore.clinicsMap.get(selectedSlot?.branch);
        if (clinic) {
          return {
            id: clinic.id,
            name: clinic.name
          }
        }

        return undefined;
      }

      return undefined;
    }, [selectedSlot])

		const makeAppointment = async () => {
      console.log(view)
      if (id&&view !== 'full') {
        localStorage.setItem('redirect_path', `/doctors-selection/${id}`);
      } else {
        localStorage.removeItem('redirect_path');
      }
			if (selectedSlot) {
        if (clinic) {
          bookingStore.setClinics([clinic])
        }
				await bookingStore.setTimeslot({
          id: selectedSlot.id,
          start: selectedSlot.start,
          staff: selectedSlot.staff,
          branch: selectedSlot.branch,
        });
        await bookingStore.setDoctorId(doctor.id);
				navigate('/appointment');
			}
		};

		return (
			<Fragment>
				{doctor.id && doctor.id === selectedSlot?.staff && (
					<div className={styles['doctor-appointement']}>
						<div className="mb-2">
							<p className={styles['doctor-appointement__text']}>
								Записаться на{' '}
								{formatWithLocale(
									new Date(selectedSlot.start),
									"d MMMM yyyy 'года,' EEEE 'в' HH:mm",
								)}
								,{' '}
								{clinic?.name}
							</p>
						</div>
						<ButtonContained
							variant={'primary'}
							onClick={makeAppointment}
              id='doctor-appointement-button'
						>
							Записаться
						</ButtonContained>
					</div>
				)}
			</Fragment>
		);
	});
